/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch } from "react-redux";
import CircularLoaderFullPage from "src/components/common/CircularLoaderFullPage/CircularLoaderFullPage";
import { OktaSignInWidget } from "src/components/common/OktaSignInWidget/OktaSignInWidget";
import { oktaAuthConfig } from "src/config/oktaConfig";
import { useAuthState } from "src/customHooks";
import { setAuthStatus } from "src/redux/authSlice";

import { localStorageKeys } from "src/constants/localStorageConstants";
import { languages } from "src/constants/i18nConstants";

export const SignIn = () => {
    const params = useParams();
    const locale = params["*"];
    const { oktaAuth } = useOktaAuth();
    const { isAuthenticated, isLoaded } = useAuthState();
    const [isLoading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { i18n } = useTranslation();

    const onSuccess = async (tokens) => {
        setLoading(true);
        //The below method not redirect to any page. We can you this method also - oktaAuth.tokenManager.setTokens(tokens);
        await oktaAuth.handleLoginRedirect(tokens);
        dispatch(setAuthStatus({ isAuthenticated: true }));
    };

    const onError = (err) => {
        console.error("error logging in", err);
    };

    useEffect(() => {
        if (locale) {
            const objectValue = getExactLocale(locale);
            localStorage.setItem(localStorageKeys.isUserPreferredLanguageSet, true);
            i18n.changeLanguage(objectValue);
        } else {
            localStorage.setItem(localStorageKeys.isUserPreferredLanguageSet, true);
            if (!i18n?.language) {
                i18n.changeLanguage(languages.en_us);
            }
        }
    }, [locale]);

    useEffect(() => {
        // Change the background color when the component mounts
        document.documentElement.style.backgroundColor = "#f0f0f0";
        document.body.style.backgroundColor = "#f0f0f0";
        // Revert the background color when the component unmounts
        return () => {
            document.documentElement.style.backgroundColor = "#ffffff";
            document.body.style.backgroundColor = "#ffffff";
            setLoading(false);
        };
    }, []);

    // Helper function to find the exact case-sensitive value from the object
    const getExactLocale = (incomingLocale) => {
        // Normalize the input: lowercase and replace underscores with dashes
        const normalizedInput = incomingLocale.toLowerCase().replace("_", "-");

        // Find a value in the object that matches our normalized input
        return Object.values(languages).find((val) => val.toLowerCase() === normalizedInput);
    };

    return (
        <Box>
            <CircularLoaderFullPage show={isLoading || !isLoaded} />
            {isLoaded && !isAuthenticated && (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <OktaSignInWidget config={oktaAuthConfig} onSuccess={onSuccess} onError={onError} />
                    </Grid>
                </Grid>
            )}
        </Box>
    );
};
